<template>
  <div class="container">
    <!-- 体验数据 -->
    <div class="block">
      <el-form size="mini" :model="searchInfo" inline>
        <div style="display: flex">
          <el-form-item>
            <common-date-range-selector
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              v-model="searchInfo.date"
              @change="searchDateChange(searchInfo.date)"
            >
            </common-date-range-selector>
          </el-form-item>
          <div class="radio-group" style="flex: 1">
            <div
              :class="`mwow-button large${
                searchInfo.range === 'month' ? ' success' : ''
              }`"
              @click="searchRangeChange('month')"
            >
              本月
            </div>
            <div
              :class="`mwow-button large${
                searchInfo.range === 'last_month' ? ' success' : ''
              }`"
              @click="searchRangeChange('last_month')"
            >
              上月
            </div>
            <div
              :class="`mwow-button large${
                searchInfo.range === 'three_month' ? ' success' : ''
              }`"
              @click="searchRangeChange('three_month')"
            >
              近3个月
            </div>
            <div
              :class="`mwow-button large${
                searchInfo.range === 'six_month' ? ' success' : ''
              }`"
              @click="searchRangeChange('six_month')"
            >
              近6个月
            </div>
            <div
              :class="`mwow-button large${
                searchInfo.range === 'twelve_month' ? ' success' : ''
              }`"
              @click="searchRangeChange('twelve_month')"
            >
              近12个月
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div class="block">
      <div class="selfheader">
        <div style="font-size: 14px">综合数据</div>
      </div>
      <div style="margin-top: 10px">
        <p style="color: #f49595; font-size: 12px">
          以下指标,按人次计算,未进行去重!!
        </p>
      </div>
      <div
        class="datas"
        v-for="(item, index) in comprehensiveData"
        :key="index"
      >
        <div class="title">
          <p>
            {{ item.title }}
          </p>
          <el-popover
            placement="top"
            width="250"
            popper-class="followuppopover"
            trigger="hover"
          >
            <div class="tipck" v-if="item.n === 1">
              <p>{{ item.popover1 }}</p>
              <p>{{ item.popover2 }}</p>
              <p>{{ item.popover3 }}</p>
              <p>{{ item.popover4 }}</p>
              <p>{{ item.popover5 }}</p>
            </div>
            <div class="tipck" v-if="item.n === 2">
              <p>{{ item.popover6 }}</p>
              <p>{{ item.popover7 }}</p>
              <p>{{ item.popover8 }}</p>
              <p>{{ item.popover9 }}</p>
              <p>{{ item.popover10 }}</p>
            </div>
            <div class="question" slot="reference">
              <div>?</div>
            </div>
          </el-popover>
        </div>
        <div class="data-item">
          <div
            :class="it.key === 'hover' ? 'item high-light' : 'item'"
            v-for="(it, ind) in item.arr"
            :key="ind"
            @click="goTetail(it)"
          >
            <div class="item-top">
              <p>{{ it.name }}</p>
            </div>
            <div class="item-bottom">{{ it.num }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="block">
      <div class="block-title">
        数据明细
        <span class="select-time">
          查询时间: {{ currentTimeRange[0] + "~" + currentTimeRange[1] }}
        </span>
      </div>
      <div>
        <div class="tabs">
          <div
            :class="checkTabs === 1 ? 'tabs-in p1 check-tabs' : 'tabs-in p1 '"
            @click="checkTabs = 1"
          >
            课程顾问
          </div>
          <div
            :class="checkTabs === 2 ? 'tabs-in check-tabs' : 'tabs-in '"
            @click="checkTabs = 2"
          >
            授课教师
          </div>
          <div
            :class="checkTabs === 3 ? 'tabs-in check-tabs' : 'tabs-in '"
            @click="checkTabs = 3"
          >
            出现方式
          </div>
          <div
            :class="checkTabs === 4 ? 'tabs-in check-tabs' : 'tabs-in '"
            @click="checkTabs = 4"
          >
            来源渠道
          </div>
          <div
            :class="checkTabs === 5 ? 'tabs-in p2 check-tabs' : 'tabs-in p2'"
            @click="checkTabs = 5"
          >
            转化课程
          </div>
        </div>
        <course-table v-if="checkTabs === 1" :time-date="currentTimeRange">
        </course-table>
        <teacher-table
          v-if="checkTabs === 2"
          :time-date="currentTimeRange"
        ></teacher-table>
        <appears v-if="checkTabs === 3" :time-date="currentTimeRange"></appears>
        <channel-table
          v-if="checkTabs === 4"
          :time-date="currentTimeRange"
        ></channel-table>
        <buy-table v-if="checkTabs === 5" :time-date="currentTimeRange">
        </buy-table>
      </div>
    </div>
  </div>
</template>
<script>
import {
  dateFormat,
  getLatestMonth,
  getCurrentMonth,
} from "@/utils/timeFormat";
import { statisticsExperienceDataApi } from "@/api/statistics";
import courseTable from "./courseTable.vue";
import teacherTable from "./teacherTable.vue";
import channelTable from "./channelTable.vue";
import buyTable from "./buyTable.vue";
import appears from "./appears.vue";
import { roundNumbers } from "@/utils/roundNumbers";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

export default {
  components: {
    courseTable,
    teacherTable,
    channelTable,
    buyTable,
    appears,
    commonDateRangeSelector,
  },
  data() {
    return {
      searchInfo: {
        date: [],
        range: "month",
      },
      currentTimeRange: [],
      checkTabs: 1,
      comprehensiveData: [],
    };
  },
  created() {
    this.searchRangeChange("month");
  },
  methods: {
    goTetail(val) {
      if (val.key === "hover") {
        const goExperience = this.$router.resolve({
          name: "experience",
          query: {
            s_time: this.currentTimeRange[0],
            e_time: this.currentTimeRange[1],
            from: "experience",
            val: "all",
          },
        });
        window.open(goExperience.href, "_blank");
      }
    },
    // 搜索交互
    searchDateChange(dates) {
      console.log("searchDateChange", dates);
      if (!dates) {
        // 清除
        this.searchInfo.range = "month";
        this.currentTimeRange = [];
        this.searchRangeChange("month");
      } else {
        this.currentTimeRange = dates || [];
        this.searchInfo.range = "free";
        this.renderTotal();
      }
    },
    searchRangeChange(type) {
      let start = "";
      let end = "";
      const now = new Date();
      switch (type) {
        case "month":
          const monthArr = getCurrentMonth(now);
          start = dateFormat("YYYY-mm-dd", monthArr[0]);
          end = dateFormat("YYYY-mm-dd", monthArr[1]);
          break;
        case "last_month":
          const d = now.getDate();
          const lastMonthArr = getCurrentMonth(
            now.getTime() - d * 24 * 60 * 60 * 1000
          );
          start = dateFormat("YYYY-mm-dd", lastMonthArr[0]);
          end = dateFormat("YYYY-mm-dd", lastMonthArr[1]);
          break;
        case "three_month":
          start = getLatestMonth(3);
          end = dateFormat("YYYY-mm-dd", now);
          break;
        case "six_month":
          start = getLatestMonth(6);
          end = dateFormat("YYYY-mm-dd", now);
          break;
        case "twelve_month":
          start = getLatestMonth(12);
          end = dateFormat("YYYY-mm-dd", now);
          break;
      }
      this.currentTimeRange = [start, end];
      this.searchInfo.range = type;
      this.searchInfo.date = [start, end];
      this.renderTotal();
    },
    renderTotal() {
      const params = {
        time_tag: this.searchInfo.range,
        start_date: this.currentTimeRange[0],
        end_date: this.currentTimeRange[1],
      };
      statisticsExperienceDataApi(params).then((res) => {
        if (res.error_code === 0) {
          this.comprehensiveData = [];
          const r = res.data;
          const experienceArr = {
            title: "体验数据",
            popover1: "预约体验数: 查询时间内所有需要体验的记录数",
            popover2: "1vN体验数: 查询时间内1vN需体验的记录数",
            popover3: "1v1体验数: 查询时间内1v1需体验的记录数",
            // popover4: "完成体验数: 查询时间内完成体验的记录数，状态为“已体验”",
            popover4: "完成体验数: 1v1完成体验数+1vN完成体验数",
            popover5: "完成体验率: 完成体验率 = 完成体验数 / 预约体验数 * 100%",
            n: 1,
            arr: [
              {
                name: "预约体验数",
                num: r.invited_count,
              },
              {
                name: "1vN体验数",
                num: r.invited_count_1vn,
              },
              {
                name: "1v1体验数",
                num: r.invited_count_1v1,
              },
              {
                name: "完成体验数",
                num: r.finish_count,
              },
              {
                name: "1v1完成体验数",
                num: r.invited_count_1v1_finish_count,
              },
              {
                name: "1vN完成体验数",
                num: r.invited_count_1vn_finish_count,
              },
              {
                name: "完成体验率",
                num: roundNumbers(r.finish_rate) + "%",
              },
            ],
          };
          const convertArr = {
            title: "转化数据",
            popover6:
              "体验转化数: 查询时间内完成体验及缴费的记录数，状态为“已体验”、“已缴费”",
            popover7: "体验转化率: 体验转化率 = 体验转化数 / 完成体验数 * 100%",
            popover8:
              "转化金额: 查询时间内完成体验及缴费的记录金额，状态为“已体验”、“已缴费”",
            popover9: "1vN金额: 已转化订单金额中，1vN金额数",
            popover10: "1v1金额: 已转化订单金额中，1v1金额数",
            n: 2,
            arr: [
              {
                name: "体验转化数",
                num: r.transform_count,
                key: "hover",
              },
              {
                name: "体验转化率",
                num: roundNumbers(r.transform_rate) + "%",
              },
              {
                name: "转化金额",
                num: roundNumbers(r.transform_amount),
              },
              {
                name: "1vN金额",
                num: roundNumbers(r.transform_amount_1vn),
              },
              {
                name: "1v1金额",
                num: roundNumbers(r.transform_amount_1v1),
              },
            ],
          };
          this.comprehensiveData.push(experienceArr, convertArr);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.block {
  background: #ffffff;
  border-radius: 4px;
  margin-bottom: 12px;
  padding: 15px 12px;
  overflow-x: hidden;
  .selfheader {
    display: flex;
    align-items: center;
    color: #5c5d5e;
  }
  .datas {
    color: #5c5d5e;
    margin: 10px 0;
    .title {
      display: flex;
      align-items: center;
      font-size: 12px;
      margin-bottom: 10px;
      width: 100px;
    }
    .data-item {
      flex: 1;
      height: 55px;
      width: 100%;
      display: flex;
      .item {
        padding: 10px;
        text-align: center;
        box-sizing: border-box;
        width: 103px;
        background: #f6fafc;
        border-right: 1px solid #f1f2f2;
        &:last-child {
          border-right: none;
        }
        .item-top {
          margin-bottom: 5px;
          font-size: 12px;
        }
        .item-bottom {
          font-size: 18px;
          font-weight: 700;
        }
        &.high-light {
          cursor: pointer;
          &:hover {
            border: 1px solid #07d1aa !important;
            background: #f0fdfa !important;
          }
        }
      }
    }
  }
  .radio-group {
    display: inline-block;
    .mwow-button {
      margin-left: 12px;
    }
  }
  .show-wrap {
    padding-bottom: 12px;
    .item {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      .el-radio-group {
        margin-left: 18px;
      }
      .label {
        font-size: 14px;
        color: #5c5d5e;
        font-weight: bold;
      }
      .center {
        flex: 1;
      }
      .right {
        display: inline-flex;
        align-items: center;
      }
    }
  }
  .chart-wrap {
    height: 350px;
  }
}
.curson {
  cursor: pointer;
}
.question {
  width: 15px;
  height: 15px;
  opacity: 1;
  background: #bebfc0;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  margin-left: 5px;
}
.persan {
  margin-top: 6px;
  .percentage {
    font-size: 12px !important;
    margin-top: 2px;
    .cont-num {
      font-size: 20px !important;
      font-weight: bold;
      margin-left: 5px;
      margin-top: -2px;
    }
  }
}
.select-time {
  margin-left: 18px;
  color: #ffb940;
  font-size: 12px;
  font-weight: 400;
}
.tabs {
  display: flex;
  margin-bottom: 15px;
  margin-top: 15px;
  .tabs-in {
    border: 1px solid #c0c7ce;
    color: #5c5d5e;
    padding: 5px 15px;
    cursor: pointer;
    border-right: 0;
    &:last-child {
      border-right: 1px solid #c0c7ce;
    }
  }
  .p1 {
    border-radius: 3px 0 0 3px;
  }
  .p2 {
    border-radius: 0 3px 3px 0;
  }
}
.check-tabs {
  border-color: #07d1aa !important;
  color: #07d1aa !important;
  & + .tabs-in {
    border-left: 1px solid #07d1aa !important;
  }
}
/deep/.el-table {
  th {
    &.is-sortable {
      .caret-wrapper {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }
      }
    }
  }
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
